import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-org-switcher',
  templateUrl: './org-switcher.component.html',
  styleUrls: ['./org-switcher.component.scss']
})
export class OrgSwitcherComponent implements OnInit {
  @Input() currentOrganization;
  @Output() organizationChange = new EventEmitter<any>();
  
  organizations = [];
  loading = false;
  showDropdown = false;

  constructor(
    private http: HttpClient,
    public authService: AuthService
  ) {}

  ngOnInit() {
    if (this.authService.isAuthenticated()) {
      const auth = this.authService.getAuthentication();
      if (auth && (auth.roles && (auth.roles.includes('SUPER_ADMIN') || auth.roles.includes('SuperAdmin')))) {
        this.loadOrganizations();
      }
    }
  }

  loadOrganizations() {
    this.loading = true;
    this.http.get(`${environment.apiBaseUrl}/v1/super-admin/organizations`, {
      headers: {
        'X-ACCESS-TOKEN': this.authService.getToken()
      }
    }).toPromise().then((orgs: any) => {
      this.organizations = orgs || [];
      this.loading = false;
    }).catch((error) => {
      console.error('Error loading organizations:', error);
      this.loading = false;
    });
  }

  selectOrganization(org) {
    this.currentOrganization = org;
    this.showDropdown = false;
    this.organizationChange.emit(org);
    // In a real app, you'd switch the organization context here
    // This might involve updating the API base URL or organization context
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  createNewOrg() {
    // Navigate to organization creation
    // This would be implemented based on your routing
    console.log('Create new organization');
  }
}
